export type AspectConfiguration = {
  id?: string;
  registryId?: string;
  fields?: string[];
  conditionExpression?: string;
}

export type CaseAction = {
  id?: string;
  name?: string;
  formId?: string;
  useRecord?: boolean;
  extensions?: string[];
  steps?: CaseActionStep[];
  meta?: Record<string, string>;
  defaultVariables?: Record<string, string>;
  defaultPostVariables?: Record<string, string>;
  disabledChecks?: unknown[];
}

export type CaseConfiguration = {
  id?: string;
  name?: string;
  registryId?: string;
  aspectId?: string;
  formId?: string;
  views?: string[];
  meta?: Record<string, unknown>;
  fields?: CaseField[];
  caseActions?: CaseAction[];
}

export type CaseField = {
  name?: string;
  length?: number;
  type?: string;
  fieldInfo?: Record<string, unknown>;
  labelId?: string;
  readOnlyExpression?: string;
  mandatoryExpression?: string;
  filter?: CaseFieldFilter;
  mobileViewOrder?: number;
}

export type DateString = string;

export type FilterCriteria = {
  tableName?: string;
  field?: string;
  operator?: FilterOperator;
  value?: string[];
}

export enum FilterOperator {
  IN = 'IN',
  EQUAL = 'EQUAL',
  LIKE = 'LIKE',
  GREATER_THAN = 'GREATER_THAN',
  GREATER_THAN_OR_EQUAL = 'GREATER_THAN_OR_EQUAL',
  LESS_THAN = 'LESS_THAN',
  LESS_THAN_OR_EQUAL = 'LESS_THAN_OR_EQUAL',
  ILIKE = 'ILIKE',
  NOT_CONTAINS = 'NOT_CONTAINS',
  NOT_EQUAL = 'NOT_EQUAL',
  NOT_IN = 'NOT_IN',
  START_WITH = 'START_WITH',
  END_WITH = 'END_WITH',
  IN_RANGE = 'IN_RANGE',
  RLIKE = 'RLIKE',
  NOT_RLIKE = 'NOT_RLIKE',
  JIN = 'JIN',
  NJIN = 'NJIN',
  IS_NULL = 'IS_NULL'
}

export type IdentityLinkInfo = {
  type?: string;
  userId?: string;
  groupId?: string;
  taskId?: string;
  processInstanceId?: string;
  scopeId?: string;
  subScopeId?: string;
  scopeType?: string;
  scopeDefinitionId?: string;
}

export type ProviderUserLink = {
  provider?: string;
  userPrincipalName?: string;
}

export type RegistryRecord = {
  key?: string;
  data?: Record<string, unknown>;
}

export type SaldoDto = {
  exportDate?: LocalDateTime;
  saldoRecords?: SaldoRecord[];
}

export type SaldoRecord = {
  tabNr?: string;
  saldo?: number;
  lisapsaldo?: number;
}

export type SortCriteria = {
  field?: string;
  order?: SortOrder;
}

export enum SortOrder {
  ASC = 'ASC',
  DESC = 'DESC',
  DEFAULT = 'DEFAULT'
}

export type StatisticsResult = {
  name?: string;
  statusStatistics?: StatusStatistics[];
}

export type StatusStatistics = {
  status?: string;
  count?: number;
}

export type Tag = {
  id?: number;
  name?: string;
}

export type TaskResponse = {
  id?: string;
  name?: string;
  businessKey?: string;
  description?: string;
  priority?: number;
  owner?: string;
  assignee?: string;
  assigneeName?: string;
  dueDate?: DateString;
  category?: string;
  formKey?: string;
  createdDate?: DateString;
  processDefinitionId?: string;
  startedBy?: string;
  startedByName?: string;
  processInstanceId?: string;
  groupingConf?: string;
  variables?: Record<string, unknown>;
  identityLinks?: IdentityLinkInfo[];
  taskDefinitionKey?: string;
  processDefinitionKey?: string;
}

export type User = {
  YESTER?: string;
  groups?: string[];
  id?: string;
  name?: string;
  phoneNumber?: string;
  email?: string;
  departmentId?: string;
  alias?: string;
  languageId?: string;
  tenantId?: string;
  enabled?: boolean;
  delegate?: string;
  delegateStart?: LocalDate;
  delegateEnd?: LocalDate;
  loginMode?: string;
  notificationsEnabled?: boolean;
  variables?: Variable[];
  userCreationType?: string;
  directManagerId?: string;
  absenceProfile?: string;
  country?: string;
  employeePosition?: string;
  companyRegistryCode?: string;
  dateOfBirth?: LocalDate;
  tags?: Tag[];
  providerLink?: ProviderUserLink[];
  validForEmailNotification?: boolean;
  delegated?: boolean;
  providerLinks?: ProviderUserLink[];
}

export type UserCountStatistics = {
  name?: string;
  count?: number;
}

export type Variable = {
  name?: string;
  value?: string;
}

export type CaseActionStep = {
  id?: string;
  priority?: number;
  type?: string;
  continueOnFail?: boolean;
  configuration?: {
    [key: string]: unknown;
  }
  getConfiguration?: {
    [key: string]: unknown;
  }
}

export type CaseFieldFilter = {
  filterComponentName?: FilterComponentNameDto;
  filterOperation?: FilterOperationDto;
  filterFieldName?: string;
  defaultValue?: string;
  defaultValueExpression?: string;
}

export type FilterComponentNameDto = 'text' | 'dropdown' | 'datepicker' | 'userDropdown'; // or enum
export type FilterOperationDto = 'like' | 'eq' | 'in' | 'gt' | 'gte' | 'lt' | 'lte' | 'ilike'; // or enum

export type Instant = string;

export type LocalDate = string;

export type LocalDateTime = string;

export type LocalTime = string

export type SyncPolicy = {
  createEnabled?: boolean;
  updatesEnabled?: boolean;
  deletePolicy?: DeletePolicy;
  deleteEnabled?: boolean;
}

export type DeletePolicy = 'DELETE' | 'DISABLE' | 'OFF';
